import script from "./dealer_camera.vue?vue&type=script&setup=true&lang=js"
export * from "./dealer_camera.vue?vue&type=script&setup=true&lang=js"

import "./dealer_camera.vue?vue&type=style&index=0&id=7d06754b&lang=css"

const __exports__ = script;

export default __exports__